import React from "react";
import styled from "styled-components";
import QuillEditor from "./QuillEditor";
import { jsx } from "react/jsx-runtime";

const QuillWrapper = styled.div`
  .ql-toolbar {
    display: flex;
    padding: 5px 0px;
  }

  .ql-editor {
    padding: 10px 20px;
    min-height: 350px;
    font-size: 1.125rem;
    line-height: 1.5;
    width: 100%;
  }

  .ql-editor .ql-blank::before {
    left: 0px;
  }
`;

const EditorBox = ({ value, setPost, post }) => {
  const onChange = content => {
    setPost(prev => ({...prev, content: content}));
  };

  return (
    <div className="EditorBox">
      <QuillWrapper>
        <QuillEditor value={value} onChange={onChange} post={post} />
      </QuillWrapper>
    </div>
  );
};

export default EditorBox;
